import { styled } from 'styled-components';
import { Simplebar } from "../../../simplebar/src";
export const StyledSimpleBar = styled(Simplebar) `
  max-height: ${({ $maxHeight, theme }) => $maxHeight || theme.dropdown.maxHeight};
  width: max-content;

  .simplebar-content {
    width: max-content;
  }

  .simplebar-wrapper {
    height: 100%;
    position: relative;
  }
`;
//# sourceMappingURL=StyledSimpleBar.js.map